import React from 'react';
import PropTypes from 'prop-types';

const UserNameDisplay = ({ user }) => {
  const { netId, name } = user;
  return <>{`${name} (${netId})`}</>;
};

UserNameDisplay.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserNameDisplay;
